/**
 * Route Constants
 *
 * Centralized route path definitions.
 * Keep this file dependency-free to avoid circular imports.
 */

export const APP_ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',

  // Auth Routes
  AUTH: {
    ROOT: '/auth',
    CALLBACK: '/auth/callback',
    GOOGLE_CALLBACK: '/google_auth/callback',
    LOGOUT: '/logout',
  },

  // Feature Routes
  CASES: {
    LIST: '/cases',
    DETAIL: '/cases/:caseId',
    getDetail: (caseId: string) => `/cases/${caseId}`,
  },
  CONTACTS: '/contacts',
  CASE_DETAIL: '/case-detail/:caseId',
  LEGACY_CASE_DETAILS: '/case-details/:caseId',
  CASE_TAGS: '/case-tags',
  ENTITIES: '/entities',
  QUEUE: '/queue',
  CALL_HISTORY: '/call-history',
  USERS: {
    LIST: '/users',
    DETAIL: '/users/:userId',
    getDetail: (userId: string | number) => `/users/${String(userId)}`,
  },
  PTP: '/ptp',
  DEFERMENTS: '/case-deferments',
  PAYMENTS: '/payments',
  CLIENTS: {
    LIST: '/clients',
    DETAIL: '/clients/:clientId',
    getDetail: (clientId: string | number) => `/clients/${String(clientId)}`,
  },
  FIELD_VISITS: '/field-visits',
  OAUTH_CLIENTS: {
    LIST: '/oauth-clients',
    DETAIL: '/oauth-clients/:clientId',
    getDetail: (clientId: string) => `/oauth-clients/${encodeURIComponent(clientId)}`,
  },
  CALL_FOLLOW_UPS: '/call-follow-ups',
  PHONE_SEARCH: '/phone-search',
} as const;
